if (!customElements.get('ayo-dock')) {
  class AyoDock extends HTMLElement {
    connectedCallback() {
      this.glow = this.querySelector('.ayo-dock__glow');
      this.items = Array.from(this.querySelectorAll('.ayo-dock__item'));
      this.resting = this.querySelector('.ayo-dock__item.is-active');
      this.wish = this.querySelector('[data-ayo-dock-wish]');
      this.cartCount = this.querySelector('[data-ayo-dock-cart-count]');

      this.place = this.place.bind(this);
      this.paintWish = this.paintWish.bind(this);

      this.items.forEach((item) => {
        item.addEventListener('click', (e) => {
          if (item.hasAttribute('data-ayo-dock-cart')) {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(item); }
          }
          this.activate(item);
        });
      });
      document.addEventListener('ayo:menu-close', () => this.activate(this.resting));
      document.addEventListener('ayo:search-close', () => this.activate(this.resting));
      window.addEventListener('resize', this.place);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.place);
      this.place();
      requestAnimationFrame(() => this.classList.add('is-ready'));

      // wishlist count (theme stores it in localStorage)
      this.paintWish();
      window.addEventListener('storage', this.paintWish);
      document.addEventListener('visibilitychange', this.paintWish);
      document.addEventListener('click', (e) => {
        if (e.target.closest('wishlist-button, .wishlist-button, [data-wishlist], .delete-item-button')) setTimeout(this.paintWish, 150);
      });

      // cart count follows the header cart icon (re-rendered by the theme after every change)
      const headerCart = document.getElementById('cart-icon-bubble');
      if (this.cartCount && headerCart) {
        const sync = () => {
          const c = headerCart.querySelector('.ayo-hd__count');
          const n = c ? parseInt(c.dataset.count, 10) || 0 : 0;
          this.cartCount.textContent = n > 99 ? '99+' : String(n);
          this.cartCount.hidden = n === 0;
        };
        new MutationObserver(sync).observe(headerCart, { childList: true, subtree: true });
      }

      // optional: hide while scrolling down
      if (this.dataset.hideOnScroll === 'true') {
        let last = window.scrollY;
        window.addEventListener('scroll', () => {
          const y = window.scrollY;
          if (Math.abs(y - last) < 6) return;
          this.classList.toggle('is-hidden', y > last && y > 120);
          last = y;
        }, { passive: true });
      }

      // theme editor: keep the highlight right when blocks change
      document.addEventListener('shopify:block:select', (e) => {
        const item = e.target.closest && e.target.closest('.ayo-dock__item');
        if (item && this.contains(item)) this.activate(item);
      });
    }

    activate(item) {
      this.items.forEach((el) => el.classList.toggle('is-active', el === item));
      this.place();
    }

    place() {
      if (!this.glow) return;
      const active = this.querySelector('.ayo-dock__item.is-active');
      this.glow.classList.toggle('has-target', !!active);
      if (!active) return;
      this.glow.style.left = `${active.offsetLeft}px`;
      this.glow.style.width = `${active.offsetWidth}px`;
      this.glow.style.top = `${active.offsetTop}px`;
      this.glow.style.height = `${active.offsetHeight}px`;
    }

    paintWish() {
      if (!this.wish) return;
      let n = 0;
      try { n = Object.keys(JSON.parse(localStorage.getItem('productDataWishlist') || '{}')).length; } catch (e) { n = 0; }
      this.wish.textContent = n > 99 ? '99+' : String(n);
      this.wish.hidden = n === 0;
    }
  }
  customElements.define('ayo-dock', AyoDock);
}
